import { render, staticRenderFns } from "./Dropzone.vue?vue&type=template&id=0b71684f"
import script from "./Dropzone.vue?vue&type=script&setup=true&lang=js"
export * from "./Dropzone.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports